export const getDistance = (dist: string) => {
  let numMiles;
  if (dist !== '') {
    numMiles = parseFloat(dist).toFixed(1);
  }
  return parseInt(numMiles, 10) > 0 ? numMiles : 0;
};
